<h2 mat-dialog-title translate="CALLS.ADMIN.SOFT_DELETION.UNMARK_TITLE"></h2>
<mat-dialog-content>
  <p translate="CALLS.ADMIN.SOFT_DELETION.UNMARK_DESCRIPTION"></p>
  <mat-checkbox [(ngModel)]="setRetentionPeriodStartDate" name="set-retention-period-start-date" [disabled]="mustSetRetentionPeriodStartDate">
    {{ 'CALLS.ADMIN.SOFT_DELETION.UNMARK_SET_RETENTION_START_DATE' | translate }}
  </mat-checkbox>
  @if (setRetentionPeriodStartDate) {
    <div class="date-picker-section">
      <app-datetime-picker
        [(ngModel)]="retentionPeriodStartDate"
        name="retention-period-start-date"
        translationKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_RETENTION_START_DATE_LABEL"
        [isDateInvalid]="!isRetentionPeriodStartDateValid"
        errorMessageKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_RETENTION_START_DATE_MUST_BE_LATER"
      ></app-datetime-picker>
      <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button
    mat-button
    [mat-dialog-close]="dialogResult"
    [disabled]="!isRetentionPeriodStartDateValid"
    translate="COMMON.SAVE"
    color="primary"
    cdkFocusInitial
  ></button>
</mat-dialog-actions>
